export default __webpack_public_path__ + "static/DSC_0083-4cb3c1a93fc143ddb261a1474ea7a442.jpg";